import angular from 'angular';

export default angular
	.module('ui.cian.prevent-submit-on-enter', [])
	.directive('cianUiPreventSubmitOnEnter', () => ({
		restrict: 'A',
		link: (scope, element) => {
			element.bind('keydown', event => {
				if (event.which === 13) {
					event.preventDefault();
					return false;
				}
			});
		}
	}))
	.name;
